import { useFirebaseToken } from '@/hooks/useFirebaseUser/useFirebaseToken'

import { useTimelineServiceGetV1IndividualsByIndividualIdTimeline } from '../client/queries'

export const useTimeline = (individualId?: string) => {
  const token = useFirebaseToken()

  return useTimelineServiceGetV1IndividualsByIndividualIdTimeline(
    { individualId: individualId! },
    undefined,
    {
      enabled: !!individualId && !!token,
    },
  )
}
